export const API_ENDPOINTS = {
  DASHBOARD: '/api/dashboard',
  STATUS: '/api/status',
  POSITIONS: '/api/positions',
  PNL: '/api/pnl',
  TODAY: '/api/today',
  WEEK: '/api/week',
  TRADES: '/api/trades',
  BUY: '/api/buy',
  SELL: '/api/sell',
  RISK: '/api/risk',
  HEALTH: '/api/health',
  SIGNALS: '/api/signals',
  ORDERS: '/api/orders',
  AUTH_LOGIN: '/api/auth/login',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_ME: '/api/auth/me',
  AUTH_CHANGE_PASSWORD: '/api/auth/change-password',
  SETTINGS: '/api/settings',
  RISK_RESET_CIRCUIT_BREAKER: '/api/risk/reset-circuit-breaker',
} as const;
